export var DEFAULT_FONT_OPACITY={identifier:"WHITE",value:"#fff",opacityLabel:"100%"};